<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [selectable]="false"
         [expandedEntry]="expandedRow"
         expandMode="preserve">
    <ui-grid-column [title]="'job_trigger_grid_trigger_status_title' | translate"
                    property="status"
                    width="25%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('JobTriggerStatus_' + entry.status | translate) as triggerStatus">
                <span [matTooltip]="triggerStatus">
                    {{ triggerStatus }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'job_trigger_grid_trigger_type_title' | translate"
                    property="triggerType"
                    width="25%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('JobTriggerType_' + entry.triggerType | translate) as triggerType">
                <span [matTooltip]="triggerType">
                    {{ triggerType }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'job_trigger_grid_trigger_message_title' | translate"
                    property="triggerMessage"
                    width="50%">
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button *ngIf="[JobTriggerType.QueueItem, JobTriggerType.Job, JobTriggerType.Task]
                        .includes(JobTriggerType[entry.triggerType])"
                    (click)="toggleRow(entry)"
                    mat-icon-button
                    type="button"
                    data-cy="job-trigger-expand">
                <mat-icon>{{ expandedRow === entry ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
            </button>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-expanded-row>
        <ng-template let-entry="data">
            <div class="trigger-details-container">
                <ng-container [ngSwitch]="JobTriggerType[entry.triggerType]">
                    <ui-job-trigger-task *ngSwitchCase="JobTriggerType.Task"
                                         [itemId]="entry.itemId">
                    </ui-job-trigger-task>
                    <ui-job-trigger-job *ngSwitchCase="JobTriggerType.Job"
                                        [itemId]="entry.itemId">
                    </ui-job-trigger-job>
                    <ui-job-trigger-queue-item *ngSwitchCase="JobTriggerType.QueueItem"
                                               [itemId]="entry.itemId">
                    </ui-job-trigger-queue-item>
                </ng-container>
            </div>
        </ng-template>
    </ui-grid-expanded-row>

</ui-grid>
